import apiCore, { withAuth } from './core';

const API_ROOT = process.env.REACT_APP_PORTAL_API;

export default {
  getAllUsers: async () => {
    try {
      const url = `${API_ROOT}v1/admin/users`;

      const { data, response } = await withAuth(apiCore.get)(url);

      if (response.status !== 200 || !data.success) {
        return [];
      }

      return data.users;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  updateUsers: async users => {
    try {
      const url = `${API_ROOT}v1/admin/users`;

      const body = JSON.stringify({
        users
      });

      const { data, response } = await withAuth(apiCore.put)(url, body);

      if (response.status !== 200 || !data.success) {
        return false;
      }

      return true;
    } catch (err) {}
  },

  sendWelcomeEmail: async user => {
    try {
      const url = `${API_ROOT}v1/admin/user/welcome`;

      const body = JSON.stringify({
        user,
        host: window.location.origin
      });

      const { data } = await withAuth(apiCore.post)(url, body);
      if (!data || !data.success) {
        return false;
      }

      return true;
    } catch (err) {}
  },

  disableDowntimeMessage: async msg => {
    const url = `${API_ROOT}v1/admin/downtime_message/${msg.uuid}`;
    const body = JSON.stringify(msg);

    try {
      const { data } = await withAuth(apiCore.post)(url, body);
      return data;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  createDowntimeMessage: async msg => {
    const url = `${API_ROOT}v1/admin/downtime_message`;
    const body = JSON.stringify(msg);

    try {
      const { data } = await withAuth(apiCore.post)(url, body);
      return data;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  generateApiKey: async user => {
    try {
      const url = `${API_ROOT}v1/admin/user/generateApiKey`;

      const body = JSON.stringify({
        user
      });

      const { data } = await withAuth(apiCore.post)(url, body);
      if (!data || !data.success) {
        return false;
      }

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  grantAdminAccess: async (user, role) => {
    try {
      const url = `${API_ROOT}v1/admin/user/access`;

      const body = JSON.stringify({
        user,
        access: role,
        revoke: false
      });

      const { data } = await withAuth(apiCore.post)(url, body);
      if (!data || !data.success) {
        return false;
      }

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  revokeAdminAccess: async user => {
    try {
      const url = `${API_ROOT}v1/admin/user/access`;

      const body = JSON.stringify({
        user,
        access: '',
        revoke: true
      });

      const { data } = await withAuth(apiCore.post)(url, body);
      if (!data || !data.success) {
        return false;
      }

      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
};
